/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_login_methods_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link or unlink login methods. All methods are equal — keep at least one enabled so you don't lock yourself out.`)
};

const zh_hans1_settings_login_methods_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绑定或解绑登录方式。所有方式都是平等的——请至少保留一种启用状态，以免被锁定。`)
};

const zh_hant1_settings_login_methods_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`綁定或解除綁定登入方式。所有方式都一樣重要——請至少保留一種啟用狀態，以免被鎖定。`)
};

const fr_settings_login_methods_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liez ou délier des méthodes de connexion. Toutes les méthodes se valent — gardez-en au moins une activée pour éviter de vous bloquer.`)
};

const de_settings_login_methods_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login-Methoden verknüpfen oder trennen. Alle Methoden sind gleichwertig – lass mindestens eine aktiv, damit du dich nicht aussperrst.`)
};

const ja_settings_login_methods_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン方法を連携/解除します。すべて同等です — ロックアウトを防ぐため、少なくとも 1 つは有効にしておいてください。`)
};

const ko_settings_login_methods_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 방법을 연결하거나 해제합니다. 모든 방법은 동일합니다 — 계정 잠금을 방지하려면 최소 하나는 활성화해 두세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_login_methods_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_login_methods_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_login_methods_desc", locale)
	if (locale === "en") return en_settings_login_methods_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_login_methods_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_login_methods_desc(inputs)
	if (locale === "fr") return fr_settings_login_methods_desc(inputs)
	if (locale === "de") return de_settings_login_methods_desc(inputs)
	if (locale === "ja") return ja_settings_login_methods_desc(inputs)
	return ko_settings_login_methods_desc(inputs)
};